/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPower = createReactComponent("power", "IconPower", [
  ["path", { d: "M7 6a7.75 7.75 0 1 0 10 0", key: "svg-0" }],
  ["path", { d: "M12 4l0 8", key: "svg-1" }]
]);

export { IconPower as default };
//# sourceMappingURL=IconPower.js.map
